import type {
  MFAccessCatalog,
  MFSelectableResource,
} from "state/members/access_v2/catalogs";

// One tap can't renew a resource that wants a reason (the stored one may be
// stale or absent) or whose access follows its roles (the roles to ask for
// are chosen each time), so those open the request modal instead.
const needsModal = (resource: MFSelectableResource): boolean =>
  resource.requiresComment || Boolean(resource.entitlements);

export const resourcesRenewedInModal = (
  catalogs: MFAccessCatalog[],
): Set<string> => {
  const ids = new Set<string>();
  for (const c of catalogs)
    for (const item of c.items)
      for (const cisr of item.catalogItemSelectableResources)
        if (needsModal(cisr.selectableResource))
          ids.add(cisr.selectableResource.id);
  return ids;
};
